import fr from 'facet-rest';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import CheckboxStandardized from 'Components/ComponentLibrary/Components/Uncategorized/Checkbox';
import AssignToMeButton from 'Components/UI/AllocationCleanUpAssignToMeButton/AssignToMeButton';
import BaseOverride from '../../BaseOverride';

export const ManagedAccountAllocationCleanupBaseOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride('householdId', { hidden: false })
  .nameOverride('leadPlannerId', { hidden: false })
  .nameOverride('name', { hidden: false })
  .nameOverride('suggestedModel', { hidden: false })
  .nameOverride('selectedModel', { hidden: false })
  .nameOverride('currentModel', { hidden: false })
  .nameOverride('modelDaysOutOfSync', { hidden: false })
  .nameOverride('currentModelDaysOutOfSync', { hidden: false })
  .nameOverride('deviationJustification', { hidden: false })
  .nameOverride('deviationJustificationAdditionalDetails', { hidden: false })
  .nameOverride('inOpsNotes', { hidden: false })
  .nameOverride('assignedInOpsAgentId', { hidden: false })
  .nameOverride('accountType', { hidden: true });

export const ManagedAccountAllocationCleanupTableOverride = fr.metaOverride({ base: ManagedAccountAllocationCleanupBaseOverride })
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('assignedInOpsAgentId', {
    readonly: false,
    _spreadPropNames: ['resource'],
    _component: () => AssignToMeButton,
  });

export const ManagedAccountAllocationCleanupDialogOverride = fr.metaOverride({ base: BaseOverride })
  .typeOverride('bool', {
    _component: () => CheckboxStandardized,
  })
  .typeOverride('string', {
    _component: () => TextField,
    multiline: true,
    rows: 5,
    maxRows: 10,
  })
  .nameOverride('householdId', { hidden: false })
  .nameOverride('objective', { hidden: false })
  .nameOverride('timeHorizon', { hidden: false })
  .nameOverride('suggestedModel', { hidden: false })
  .nameOverride('daysSinceSuggestedModelChange', { hidden: false })
  .nameOverride('currentModelDaysOutOfSync', { hidden: false })
  .nameOverride('needsAttention', { hidden: false })
  .nameOverride('currentModel', { hidden: false })
  .nameOverride('needsOpsAttention', { hidden: false })
  .nameOverride('isEsg', { hidden: false })
  .nameOverride('isRetirementModel', { hidden: false })
  .nameOverride('useLegacyAssetSolution', { hidden: false })
  .nameOverride('name', { hidden: false })
  .nameOverride('accountNumber', { hidden: false })
  .nameOverride('balance', { hidden: false });

export const getManagedAccountAllocationCleanupTableFilters = (collection, householdSearch, leadPlannerOptions, invOpsAgentOptions, currentModelOptions) => {
  const filters = [
    {
      name: 'householdId',
      overrideOptions: householdSearch ? householdSearch.map(search => ({
        name: `${search.attributes.primaryClientFirstName} ${search.attributes.primaryClientLastName} [${search.id}]`,
        value: search.id.toString(),
      })) : [],
      query: 'getManagedAccountAllocationCleanups',
      _setQueryParam: true,
    },
    {
      name: 'leadPlannerId',
      overrideOptions: leadPlannerOptions.map(option => ({
        name: `${option.attr('prompt')} [${option.attr('id')}]`,
        value: option.attr('id'),
      })),
      query: 'getManagedAccountAllocationCleanups',
      _setQueryParam: true,
    },
  ];

  if (!collection.meta().field('dismissed').attr('hidden')) {
    filters.push({
      name: 'assignedInOpsAgent',
      overrideOptions: invOpsAgentOptions.map(option => ({
        name: option.attr('prompt'),
        value: option.attr('id'),
      })),
      query: 'getManagedAccountAllocationCleanups',
      _setQueryParam: true,
    });
    filters.push({
      name: 'currentModel',
      overrideOptions: currentModelOptions.map(option => ({
        name: option.attr('prompt'),
        value: option.attr('id'),
      })),
      query: 'getManagedAccountAllocationCleanups',
      _setQueryParam: true,
    });
  }

  filters.push(
    {
      name: 'needsAttention',
      query: 'getManagedAccountAllocationCleanups',
    },
    {
      name: 'needsOpsAttention',
      query: 'getManagedAccountAllocationCleanups',
    },
    {
      name: 'excludeZeroBalance',
      query: 'getManagedAccountAllocationCleanups',
    },
  );
  if (!collection.meta().field('dismissed').attr('hidden')) {
    filters.push({
      name: 'dismissed',
      query: 'getManagedAccountAllocationCleanups',
    });
  }
  return filters;
};
